import { useEffect } from "react";
import { storeConfig } from "../config/store.config";

// Per-page SEO: updates <title>, meta description & canonical without any
// external dependency. Cloudflare-friendly (runs client-side).
const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const useSeo = ({ title, description, path } = {}) => {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — ${storeConfig.storeName}`
      : `${storeConfig.storeName} — ${storeConfig.tagline}`;
    document.title = fullTitle;

    setMeta("description", description);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description, "property");

    const url = `https://${storeConfig.domain}${path || window.location.pathname}`;
    setMeta("og:url", url, "property");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path]);
};

export default useSeo;
